import React, { useEffect, useState } from 'react';
import { FaCheck, FaPlus, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select';

const MatirialRequest = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const id = user ? user.id : null;
    const [supplierFilter, setSupplierFilter] = useState(null);
    const [currentDate, setCurrentDate] = useState('');


    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);

    // const handleSave = async () => {
    //     console.log('Save functionality to be implemented');
    // };

    const handlePrint = () => {
        console.log('Print functionality');
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleConfirm = () => {
        console.log('Confirm MRN creation');
    };

    const handleCancel = () => {
        setSupplierFilter(null);
        toggleModal();
    };

    const handleApprove = (id) => {

    };

    const handleRefresh = () => {

    };

    const [showEditformm, setShowEditFormm] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showViewForm, setShowViewForm] = useState(false);

    const [visibleRows, setVisibleRows] = useState()
    useEffect(() => {
        const totalRows = '';
        const emptyRowsNeeded = totalRows < 4 ? 4 - totalRows : 0;
        setVisibleRows([...'', ...Array(emptyRowsNeeded).fill({})]);
    }, ['']);



    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };
    const [formMode, setFormMode] = useState('');
    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[2000].sub_ids[2005]?.permissions.add_permission || 0,
            edit: user.permissions[2000].sub_ids[2005]?.permissions.edit_permission || 0,
            view: user.permissions[2000].sub_ids[2005]?.permissions.view_permission || 0,
            save: user.permissions[2000].sub_ids[2005]?.permissions.save_permission || 0,
            approve: user.permissions[2000].sub_ids[2005]?.permissions.approve_permission || 0,
            print: user.permissions[2000].sub_ids[2005]?.permissions.print_permission || 0,
            close: user.permissions[2000].sub_ids[2005]?.permissions.exit_permission || 0,
            clear: user.permissions[2000].sub_ids[2005]?.permissions.refresh_permission || 0
        }
        : {};
    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };


    const [departments, setDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [items, setItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [employee, setEmployee] = useState(false);
    const [formData, setFormData] = useState({

        Dept_id: '',
        Indent_Req_by: id,
        MR_Dt: new Date().toISOString().split('T')[0],

    });


    const [rows, setRows] = useState(Array.from({ length: 10 }, () => ({ itemCd: '', itemDesc: '', itemUOM: '', requiredQty: '', remarks: '', })));
    const handleAddRow = () => {
        setRows((prevRows) => [
            ...prevRows,
            { itemCd: '', itemDesc: '', itemUOM: '', Req_dt: '', Supp_id: '', Qty: '', Remarks: '', Approved_qty: '', Approved_by: '', close: '' }
        ]);
    };

    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/location')
            .then((response) => {
                setLocations(response.data);
            })
            .catch((error) => {
                console.error('Error fetching main groups:', error);
            });

        axios.get('https://erpapi.emedha.in/pages/api/api/depertament')
            .then((response) => {
                setDepartments(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/suppliers')
            .then((response) => {
                setSuppliers(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/itemsmasterform')
            .then((response) => {
                setItems(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/employeee')
            .then((response) => {
                setEmployee(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
    }, []);

    const [stockData, setStockData] = useState([]);
    const fetchStq = () => {
        fetch('https://erpapi.emedha.in/pages/api/get-stock-quantity')  // API endpoint
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();  // Parse the JSON from the response
            })
            .then((data) => {
                setStockData(data);  // Update the state with the fetched data
            })
            .catch((error) => {
                console.error('Error fetching stock data:', error);
            });
    };

    useEffect(() => {
        fetchStq();  // Call the custom fetchStq function to get the stock data
    }, []);


    const handleDeptChange = (event) => {
        const selectedDeptId = event.target.value;
        setFormData({
            ...formData,
            Dept_id: selectedDeptId
        });
    };

    const handleDeptChange1 = (selectedOption) => {
        setFormData({
            ...formData,
            Dept_id: selectedOption ? selectedOption.value : ''
        });
    };

    const departmentOptions = departments.map(dept => ({
        value: dept.Dept_id,
        label: dept.Dept_name
    }));

    const departmentOptions1 = departments.map(dept => ({
        value: dept.Dept_id,
        label: dept.Dept_name
    }));
    const handleItemChange = (index, selectedOption) => {
        if (!selectedOption) return;

        const selectedItemCd = selectedOption.value;
        const selectedItem = items.find(item => item.itemCd === selectedItemCd);
        const stockItem = stockData.find(stock => stock.item_cd === selectedItemCd);

        if (selectedItem || stockItem) {
            const newRows = [...rows];

            if (selectedItem) {
                newRows[index] = {
                    ...newRows[index],
                    itemCd: selectedItem.itemCd,
                    itemDesc: selectedItem.itemDesc,
                    itemUOM: selectedItem.itemUOM,
                };
            }

            if (stockItem) {
                newRows[index] = {
                    ...newRows[index],
                    stk_qty: stockItem.stk_qty || 0,
                };
            }
            setRows(newRows);
        } else {
            console.error("Item or stock data not found for item code:", selectedItemCd);
        }
    };

    const itemOptions = items.map((item) => ({
        value: item.itemCd,
        label: `${item.itemCd}-${item.itemDesc}`,
    }));

    const [MR_No, setMR_No] = useState("");

    useEffect(() => {
        const fetchLatestMRN = async () => {
            try {
                const response = await fetch('https://erpapi.emedha.in/pages/api/api/get-latest-mr');
                const data = await response.json();
                const latestMRN = data.latestMRN;

                // Set MRN_No to the next available value
                setMR_No(latestMRN === 0 ? "1" : (parseInt(latestMRN) + 1).toString());
            } catch (error) {
                console.error('Error fetching latest MRN:', error);
            }
        };

        fetchLatestMRN();
    }, []);

    const handleSave = async () => {

        const formDataToSubmit = {
            hdrData: {

                Dept_id: formData.Dept_id,
                Indent_Req_by: formData.Indent_Req_by,
                MR_Dt: formData.MR_Dt,
            },
            dtlData: rows.map(row => ({
                itemCd: row.itemCd,
                itemDesc: row.itemDesc,
                itemUOM: row.itemUOM,
                requiredQty: row.requiredQty,
                remarks: row.remarks,
                // Add Stk_qty if needed from the row
                Stk_qty: row.stk_qty,
            }))
        };

        try {
            const response = await axios.post('https://erpapi.emedha.in/pages/api/api/material-indent', formDataToSubmit);
            if (response.status === 201) {
                alert(`Material Indent saved successfully. MR_No: ${response.data.MR_No}`);
                window.location.reload();
            }
        } catch (error) {
            console.error('Error saving material indent:', error);
            alert('There was an error saving the material indent.');
        }
    };
    const handleQtyChange = (index, e) => {
        const newRows = [...rows];
        newRows[index].requiredQty = e.target.value;
        setRows(newRows);
    };

    const handleRemarksChange = (index, e) => {
        const newRows = [...rows];
        newRows[index].remarks = e.target.value;
        setRows(newRows);
    };

    const [MRNo, setMRNo] = useState(''); // MR_No (Material Requisition No)
    const [mrNos, setMrNos] = useState([]); // Array of MR_No values
    const [hdrData, setHdrData] = useState({}); // To store header data
    const [dtlData, setDtlData] = useState([]); // To store detail data
    const [loading, setLoading] = useState(false); // For loading state
    const [error, setError] = useState(null); // To handle any errors

    // Fetch the list of MR_No values when the component mounts
    useEffect(() => {
        const fetchMrNos = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/material-indent/mrnos');
                setMrNos(response.data.mrNos); // Populate MR_No list
            } catch (err) {
                setError('Error fetching MR_Nos');
            }
        };

        fetchMrNos();
    }, []);

    // Fetch data when MR_No changes
    useEffect(() => {
        if (!MRNo) return; // Skip fetching if MRNo is not provided

        const fetchData = async () => {
            setLoading(true); // Set loading to true
            setError(null); // Reset error state

            try {
                // Make the GET request to the backend API
                const response = await axios.get(`https://erpapi.emedha.in/pages/api/api/material-indent/${MRNo}`);
                console.log(response.data.data)
                // Set the header and detail data to state
                setHdrData(response.data.data.hdrData);
                setDtlData(response.data.data.dtlData);
            } catch (err) {
                setError('Error fetching data');
            } finally {
                setLoading(false); // Set loading to false after request completes
            }
        };

        fetchData();
    }, [MRNo]);

    const mrnOptions = mrNos.map((mr) => ({
        value: mr.MR_No, // MR_No as value
        label: mr.MR_No, // MR_No as label
    }));

    // Handle selection change
    const handleMRNChange = (selectedOption) => {
        setMRNo(selectedOption ? selectedOption.value : ''); // Update MRNo state based on selected option
    };


    // Handle changes for header data (like Request_by, Dept)
    const handleHdrChange = (e) => {
        const { name, value } = e.target;
        setHdrData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle changes for Item_code in detail rows
    const handleItemCodeChange = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Item_code = value;
        setDtlData(updatedDtlData);
    };

    // Handle changes for Item_description in detail rows
    const handleItemDescriptionChange = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Item_description = value;
        setDtlData(updatedDtlData);
    };

    // Handle changes for UOM (Unit of Measure) in detail rows
    const handleUOMChange = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].UOM = value;
        setDtlData(updatedDtlData);
    };

    // Handle changes for Stock Quantity in detail rows
    const handleStkQtyChange = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Stk_qty = value;
        setDtlData(updatedDtlData);
    };

    // Handle changes for Required Quantity in detail rows
    const handleQtyChangee = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Required_qty = value;
        setDtlData(updatedDtlData);
    };

    // Handle changes for Remarks in detail rows
    const handleRemarksChangee = (index, e) => {
        const { value } = e.target;
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Remarks = value;
        setDtlData(updatedDtlData);
    };
    const handleItemCodeChangee = (index, selectedOption) => {
        const selectedItemCode = selectedOption ? selectedOption.value : '';
        const selectedItem = items.find(item => item.itemCd === selectedItemCode);

        if (selectedItem) {
            const updatedDtlData = [...dtlData];
            updatedDtlData[index] = {
                ...updatedDtlData[index],
                Item_code: selectedItem.itemCd,
                Item_description: selectedItem.itemDesc,
                UOM: selectedItem.itemUOM,
            };
            setDtlData(updatedDtlData);
        }
    };

    const [success, setSuccess] = useState(false);

    const handleSubmit = async () => {

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await axios.put(`https://erpapi.emedha.in/pages/api/api/material-indent/${MRNo}`, {
                hdrData,
                dtlData
            });

            // Check if response status is 200 (successful)
            if (response.status === 200) {
                // Show success alert with the MR_No
                alert(`Material Indent saved successfully. MR_No: ${response.data.MR_No}`);
            } else {
                // Handle non-200 status codes if needed
                alert('Something went wrong, please try again.');
            }

            setSuccess(true);
            setLoading(false);
        } catch (err) {
            setError('Error updating data');
            setLoading(false);
        }
    };

    function formatDateToDateInput(date) {
        // Convert date string to a Date object
        const dateObj = new Date(date);

        // Adjust for timezone offset and convert to 'YYYY-MM-DD' format
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
        const day = dateObj.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }


    // ui css 

    const iconBox = (enabled) => ({
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
        boxShadow: enabled ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
        cursor: enabled ? "pointer" : "not-allowed",
        opacity: enabled ? 1 : 0.5,
        transition: "all 0.3s ease",
    });

    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        borderRadius: "14px",
        background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    };

    const titleStyle = {
        color: "#1e3a8a",
        fontSize: "2rem",
        fontWeight: "700",
        letterSpacing: "1px",
    };

    const iconContainer = {
        display: "flex",
        gap: "14px",
        alignItems: "center",
    };


    return (
        <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={A1} alt="item" style={{ width: "20%" }} />
                <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>MATERIAL REQUEST </h1>
                <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                    }}>
                        <FaPlus size={30} onClick={() => {
                            if (userPermissions.add && userPermissions.add !== 0) {
                                toggleModal();
                                setShowEditFormm(false);
                                setShowCreateForm(true);
                                // setShowViewForm(false);
                                setFormMode('create');
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                    }}>
                        <MdEdit size={30} onClick={() => {
                            if (userPermissions.edit && userPermissions.edit !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(false);
                                setFormMode('edit');
                            } else {
                                alert("You do not have permission to edit.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                    }}>
                        <LuView size={30} onClick={() => {
                            if (userPermissions.view && userPermissions.view !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(true);
                                setFormMode('view');
                            } else {
                                alert("You do not have permission to view.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                        opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                    }}>
                        <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                    </div>

                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                        opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                    }}>
                        <FaSave size={30} o onClick={() => {
                            //userPermissions.save && userPermissions.save !== 0 ? handleSave : null} />
                            if (userPermissions.save && userPermissions.save !== 0) {
                                if (formMode === 'create') {
                                    handleSave(); // If formMode is approve, use handleApprove
                                } else if (formMode === 'edit') {
                                    handleSubmit(); // If formMode is create or edit, use handleSave
                                }
                            } else {
                                alert("You do not have permission to save.");
                            }
                        }}
                        />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                        opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                    }}>
                        <FaCheck size={30} onClick={userPermissions.approve && userPermissions.approve !== 0 ? handleApprove : null} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                        opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                    }} title='Print'>
                        <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                    </div>
                </div>
            </div> */}

            <div style={headerStyle}>

                {/* Logo */}
                <img src={A1} alt="material-request" style={{ width: "270px", borderRadius: "10px" }} />

                {/* Title */}
                <h1 style={titleStyle}>MATERIAL REQUEST</h1>

                {/* Actions */}
                <div style={iconContainer}>

                    {/* Add */}
                    <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
                        <FaPlus size={20} color="#2563eb"
                            onClick={() => {
                                if (userPermissions.add && userPermissions.add !== 0) {
                                    toggleModal();
                                    setShowEditFormm(false);
                                    setShowCreateForm(true);
                                    setFormMode('create');
                                }
                            }}
                        />
                    </div>

                    {/* Edit */}
                    <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
                        <MdEdit size={20} color="#f59e0b"
                            onClick={() => {
                                if (userPermissions.edit && userPermissions.edit !== 0) {
                                    setShowEditFormm(true);
                                    setShowCreateForm(false);
                                    setFormMode('edit');
                                } else {
                                    alert("You do not have permission to edit.");
                                }
                            }}
                        />
                    </div>

                    {/* View */}
                    <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
                        <LuView size={20} color="#10b981"
                            onClick={() => {
                                if (userPermissions.view && userPermissions.view !== 0) {
                                    setShowEditFormm(true);
                                    setShowCreateForm(false);
                                    setFormMode('view');
                                } else {
                                    alert("You do not have permission to view.");
                                }
                            }}
                        />
                    </div>

                    {/* Refresh */}
                    <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
                        <HiOutlineRefresh size={20} color="#6366f1"
                            onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
                        />
                    </div>

                    {/* Save */}
                    <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
                        <FaSave size={20} color="#22c55e"
                            onClick={() => {
                                if (userPermissions.save && userPermissions.save !== 0) {
                                    if (formMode === 'create') {
                                        handleSave();
                                    } else if (formMode === 'edit') {
                                        handleSubmit();
                                    }
                                } else {
                                    alert("You do not have permission to save.");
                                }
                            }}
                        />
                    </div>

                    {/* Approve */}
                    <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
                        <FaCheck size={20} color="#16a34a"
                            onClick={userPermissions.approve && userPermissions.approve !== 0 ? handleApprove : null}
                        />
                    </div>

                    {/* Print */}
                    <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))} title="Print">
                        <IoPrint size={20} color="#0ea5e9"
                            onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
                        />
                    </div>

                    {/* Close */}
                    <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))} title="Exit">
                        <RiCloseLargeFill size={20} color="#ef4444"
                            onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                        />
                    </div>

                </div>
            </div>
            <hr />
   {!showCreateForm && !showEditformm && !showViewForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}
            {showCreateForm && (

                <>
                    <div>
                        <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '36px' }}>
                            <div style={{ flex: '1 1 48%', paddingRight: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '51px', color: 'darkblue' }}>MR.No:</label>
                                    <input readOnly
                                        //  value={MR_No} 
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '100%', outline: 'none', backgroundColor: 'transparent' }} />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                                    <label style={{ marginRight: '69px', color: 'darkblue' }}>Dept:</label>
                                    <Select
                                        name="Dept_id"
                                        value={departmentOptions.find(option => option.value === formData.Dept_id) || null}
                                        onChange={handleDeptChange1}
                                        options={departmentOptions}
                                        placeholder="Select"
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '50%' }),
                                            menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                            menu: (provided) => ({ ...provided, width: '80%', maxHeight: '100px', overflowY: 'auto' }),
                                            control: (provided) => ({ ...provided, backgroundColor: 'transparent', height: '35px' }),
                                            singleValue: (provided) => ({ ...provided, color: 'black' }),
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                                    <label style={{ marginRight: '22px', color: 'darkblue' }}>Request.By:</label>
                                    <input name="Indent_Req_by" value={user ? user.Emp_Name : ''} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', margin: '4px 0', width: '20%', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                    <input type="hidden" name="Indent_Req_by_id" value={user ? user.User_id : ''} />
                                </div>
                            </div>

                            <div style={{ flex: '1 1 48%' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '40px', color: 'darkblue' }}>MR.Dt:</label>
                                    <input type="date" value={currentDate} onChange={(e) => setCurrentDate(e.target.value)} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} />
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: '120px', overflowY: 'auto', maxHeight: '280px', }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>SI.No</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>STK QTY</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Required Qty</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remarrks</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ border: '1px solid black', }}>{index + 1}</td>
                                            <td style={{ border: '1px solid black' }}>
                                                <Select
                                                    options={itemOptions}
                                                    value={itemOptions.find(option => option.value === rows[index]?.itemCd)}
                                                    onChange={(selectedOption) => handleItemChange(index, selectedOption)}
                                                    isDisabled={formMode === 'view'}
                                                    placeholder="Select Item"
                                                    styles={{
                                                        container: (provided) => ({ ...provided, width: '100%', }),
                                                        control: (provided) => ({ ...provided, outline: 'none', backgroundColor: 'transparent', color: 'darkblue', }),
                                                        menu: (provided) => ({ ...provided, overflowY: 'auto', }),
                                                    }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', }}>{formMode === 'view' ? (<span>{row.itemDesc}</span>) : (<input type="text" value={row.itemDesc} readOnly={formMode === 'view'} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue' }} />)}</td>
                                            <td style={{ border: '1px solid black', }}>{formMode === 'view' ? (<span>{row.itemUOM}</span>) : (<input type="text" value={row.itemUOM} readOnly={formMode === 'view'} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue' }} />)}</td>
                                            <td style={{ border: '1px solid black', }}><input type="number" className="form-control" value={row.stk_qty || 0} readOnly={true} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue' }} /></td>
                                            <td style={{ border: '1px solid black' }}><input type="number" className="form-control" value={row.requiredQty} onChange={(e) => handleQtyChange(index, e)} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue' }} onInput={(e) => { if (e.target.value.length > 10) e.target.value = e.target.value.slice(0, 10); }} /> </td>
                                            <td style={{ border: '1px solid black', }}><input type="text" className="form-control" value={row.remarks} onChange={(e) => handleRemarksChange(index, e)} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue' }} /></td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}><button onClick={handleAddRow} style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}><FaPlus /> Add Row</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </>

            )}

            <>
                {showEditformm && (
                    <div>
                        <div className="p-1" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '36px' }}>
                            <div style={{ flex: '1 1 48%', paddingRight: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '51px', color: 'darkblue' }}>MR.No:</label>
                                    <Select
                                        options={mrnOptions}
                                        value={mrnOptions.find((option) => option.value === MRNo)}
                                        onChange={handleMRNChange}
                                        placeholder="Select Material Requisition No"
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '50%', padding: '6px' }),
                                            menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                            menu: (provided) => ({ ...provided, width: '80%', maxHeight: '100px', overflowY: 'auto' }),
                                            control: (provided) => ({ ...provided, backgroundColor: 'transparent', height: '35px' }),
                                            singleValue: (provided) => ({ ...provided, color: 'black' }),
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                                    <label style={{ marginRight: '69px', color: 'darkblue' }}>Dept:</label>
                                    <select name="Dept_id" value={hdrData?.Dept || ''} onChange={handleDeptChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent', }} disabled={formMode === 'view'}>
                                        <option value="">Select</option>
                                        {departments.map((Dept_id) => (
                                            <option key={Dept_id.Dept_id} value={Dept_id.Dept_id}>
                                                {Dept_id.Dept_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
                                    <label style={{ marginRight: '22px', color: 'darkblue' }}>Request By:</label>
                                    <input name="Indent_Req_by"
                                        value={hdrData && employee.find(emp => emp.Emp_id === hdrData.Request_by)?.Emp_Name || ''}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', margin: '4px 0', width: '20%', outline: 'none', backgroundColor: 'transparent', }} disabled={formMode === 'view'} />
                                    <input type="hidden" name="Indent_Req_by_id" value={user ? user.User_id : ''} />

                                </div>
                            </div>

                            {hdrData && (
                                <div style={{ flex: '1 1 48%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '40px', color: 'darkblue' }}>MR Dt:</label>
                                        <input type="date" value={hdrData.MR_Dt ? formatDateToDateInput(hdrData.MR_Dt) : ''} onChange={(e) => { const updatedMRNData = { ...hdrData, MR_Dt: e.target.value }; setHdrData(updatedMRNData); }} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent', }} disabled={formMode === 'view'} />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div style={{ marginTop: '120px', overflowY: 'auto', maxHeight: '280px' }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>SI.No</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Description</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>STK QTY</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Required Qty</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(MRNo ? [...dtlData, ...new Array(10 - dtlData.length).fill({})] : new Array(10).fill({})).map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ border: '1px solid black' }}>{row.MR_No || '-'}</td>
                                            <td style={{ border: '1px solid black' }}>
                                                <Select
                                                    styles={{
                                                        container: (provided) => ({ ...provided, width: '100%' }),
                                                        control: (provided) => ({ ...provided, outline: 'none', backgroundColor: 'transparent', color: 'darkblue' }),
                                                        menu: (provided) => ({ ...provided, maxHeight: '100px', overflowY: 'auto' }),
                                                    }}
                                                    value={
                                                        items.find((item) => item.itemCd === row.Item_code)
                                                            ? { value: row.Item_code, label: `${row.Item_code}-${row.Item_description}` }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => handleItemCodeChangee(index, selectedOption)}
                                                    options={items.map((item) => ({
                                                        value: item.itemCd,
                                                        label: `${item.itemCd} - ${item.itemDesc}`,
                                                    }))}
                                                    isDisabled={formMode === 'view'}
                                                    placeholder="Select Item"
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black' }}><input type="text" value={row.Item_description || ''} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue', }} readOnly={formMode === 'view'} /></td>
                                            <td style={{ border: '1px solid black' }}><input type="text" value={row.UOM || ''} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue', }} readOnly={formMode === 'view'} /></td>
                                            <td style={{ border: '1px solid black' }}><input type="number" className="form-control" value={row.Stk_qty || 0} onChange={(e) => handleStkQtyChange(index, e)} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue', }} readOnly={formMode === 'view'} /></td>
                                            <td style={{ border: '1px solid black' }}><input type="number" className="form-control" value={row.Required_qty || 0} onChange={(e) => handleQtyChangee(index, e)} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue', }} readOnly={formMode === 'view'} /></td>
                                            <td style={{ border: '1px solid black' }}><input type="text" className="form-control" value={row.Remarks || ''} onChange={(e) => handleRemarksChangee(index, e)} style={{ width: '100%', border: 'none', backgroundColor: 'transparent', color: 'darkblue', }} readOnly={formMode === 'view'} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}


            </>


        </div>
    );
};

export default MatirialRequest;

